import Client from './client';
import cookies from './cookies';
import { createInstance } from '@optimizely/optimizely-sdk';
import { getLogger } from './logger';
import tealium from './tealium';
export function createClient(platform, options) {
    const { initialDatafile, sdkKey, onFeatureRequest, onExperimentRequest } = options;
    const optimizelyClient = createInstance({ datafile: initialDatafile, sdkKey, logger: getLogger() });
    return Client({
        optimizelyClient,
        overrides: cookies.getOverrides(),
        getUserId: () => tealium.getVisitorId() || cookies.getVisitorId() || '',
        getUserAttributes: () => ({ audiences: tealium.getAudiences(), platform }),
        onFeatureRequest,
        onExperimentRequest,
    });
}
